"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
var FOCUS_ACTION;
(function (FOCUS_ACTION) {
    FOCUS_ACTION["next"] = "next";
    FOCUS_ACTION["prev"] = "prev";
    FOCUS_ACTION["current"] = "current";
    FOCUS_ACTION["reset"] = "reset";
})(FOCUS_ACTION = exports.FOCUS_ACTION || (exports.FOCUS_ACTION = {}));
/**
 * @hidden
 */
exports.focusReducer = function (state, action) {
    var currentIndex = action.items.findIndex(function (i) { return i === state; });
    switch (action.type) {
        case FOCUS_ACTION.next:
            return currentIndex === action.items.length - 1
                ? state
                : action.items[currentIndex + 1];
        case FOCUS_ACTION.prev:
            return currentIndex === 0
                ? state
                : action.items[currentIndex - 1];
        case FOCUS_ACTION.current:
            return action.payload;
        case FOCUS_ACTION.reset:
            return null;
        default:
            return state;
    }
};
//# sourceMappingURL=focus-reducer.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-buttons@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-buttons/dist/npm/Chip/focus-reducer.js
// module id = 282
// module chunks = 0